export const domainPrices = {
  com: 12.95,
  net: 12.95,
  org: 12.95,
  online: 34.0,
  store: 34.0,
  shop: 43.95,
  info: 12.95,
  biz: 13.95,
  club: 12.95
};
